import script from "./Revenue.vue?vue&type=script&setup=true&lang=js"
export * from "./Revenue.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__